<div class="container">
  <header class="home-header">
    <div class="notifications-container">
      @if(isGreetings){
        <div class="go-premium" matRipple (click)="goTo('choose-plan')">
        @if(psychologist() 
          && psychologist()?.status === STATUS.ACTIVE.code
          && ( psychologist()?.subscription_plan === PLANS.STARTER.code || !psychologist()?.subscription_plan) ){
            <mat-icon>workspace_premium</mat-icon>
            <span>{{ 'home.activate_plan' | translate }}</span>
        }
        </div>
        <div class="others">          
          <mat-icon matRipple (click)="goTo('calendar')">calendar_month</mat-icon>
          <span matRipple (click)="goTo('sos')">SOS</span>
          <mat-icon matRipple (click)="account()">person</mat-icon>
        </div>
      }@else if(isHistorical){
        <div class="go-premium" matRipple (click)="goTo('choose-plan')">
        @if(psychologist() 
          && psychologist()?.status === STATUS.ACTIVE.code
          && ( psychologist()?.subscription_plan === PLANS.STARTER.code || !psychologist()?.subscription_plan) ){
            <mat-icon>workspace_premium</mat-icon>
            <span>{{ 'home.activate_plan' | translate }}</span>
        }
        </div>
        <div class="others">          
          <mat-icon matRipple (click)="goTo('calendar')">calendar_month</mat-icon>          
          <span matRipple (click)="goTo('sos')">SOS</span>
          <mat-icon matRipple (click)="account()">person</mat-icon>
        </div> 
      }@else if(isProfile){
        <div class="go-premium" matRipple (click)="goTo('choose-plan')">
        @if(psychologist() 
          && psychologist()?.status === STATUS.ACTIVE.code
          && ( psychologist()?.subscription_plan === PLANS.STARTER.code || !psychologist()?.subscription_plan) ){
            <mat-icon>workspace_premium</mat-icon>
            <span>{{ 'home.activate_plan' | translate }}</span>
        }
        </div>
        <div class="others">
          <mat-icon matRipple (click)="goTo('calendar')">calendar_month</mat-icon>
          <span matRipple (click)="goTo('sos')">SOS</span>
          <mat-icon matRipple (click)="account()">person</mat-icon>
        </div>
      }
    </div>
  </header>

  <main class="home-content">
    <router-outlet name="home" />
  </main>

  <footer class="home-menu">
    <app-bottom-navigator></app-bottom-navigator>    
  </footer>
  
</div>
